const vapeblue = {
    id: 'vapeblue',
    publicSiteName: 'Vape Blue',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#00aeef',
            secondary: '#0c2d43',
            color1: '#1239ba',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapeblue/favicon.ico',
        logo: '/vapeblue/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapeblue